export default () => {
  const elements = document.querySelectorAll('.js-parent-click')
  if (elements.length < 1) return
  ;[...elements].forEach(element => {
    const trigger = element.querySelector('.js-child-click')

    if (trigger) {
      trigger.addEventListener('click', e => {
        element.classList.toggle('active')

        if (trigger.classList.contains('c-images__button-container')) {
          trigger.remove()
        }
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/ChildClick.js